import type {
  DashboardExperienceActionResponse,
  DashboardExperienceDownloadAppResponse,
  DashboardExperienceRafCampaignResponse,
  DashboardExperienceRafStatusResponse,
} from '@library/api-dashboard-experience'
import React from 'react'

import { DashboardActions } from '../DashboardActions'
import { dashboardActionRoutes } from './dashboardActionRoutes'

type DashboardLegacyActionsProps = {
  actions: DashboardExperienceActionResponse[]
  downloadApp?: DashboardExperienceDownloadAppResponse | null
  rafCampaign?: DashboardExperienceRafCampaignResponse | null
  rafStatus?: DashboardExperienceRafStatusResponse | null
  onActionClick: (actionType: DashboardExperienceActionResponse['type']) => void
}

const canRenderLegacyAction = (
  action: DashboardExperienceActionResponse,
  {
    downloadApp,
    rafCampaign,
    rafStatus,
  }: {
    downloadApp?: DashboardExperienceDownloadAppResponse | null
    rafCampaign?: DashboardExperienceRafCampaignResponse | null
    rafStatus?: DashboardExperienceRafStatusResponse | null
  },
) => {
  if (action.type === 'downloadApp') {
    return Boolean(downloadApp)
  }

  if (action.type === 'raf') {
    return Boolean(rafStatus || rafCampaign)
  }

  return Boolean(action.title && dashboardActionRoutes[action.type])
}

export function DashboardLegacyActions({
  actions,
  downloadApp,
  rafCampaign,
  rafStatus,
  onActionClick,
}: DashboardLegacyActionsProps) {
  const renderableActions = actions.filter((action) =>
    canRenderLegacyAction(action, { downloadApp, rafCampaign, rafStatus }),
  )

  if (!renderableActions.length) {
    return null
  }

  return (
    <section aria-label="dashboard actions" style={{ width: '100%' }}>
      <DashboardActions
        actions={renderableActions}
        downloadApp={downloadApp}
        rafCampaign={rafCampaign}
        rafStatus={rafStatus}
        onActionClick={onActionClick}
      />
    </section>
  )
}
